const flagTypes = {
    SET_FLAG: "SET_FLAG",
};

export default flagTypes;
